// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Orbitron-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Orbitron-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Orbitron-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/Orbitron-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/Orbitron-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/Orbitron-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Orbitron";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Orbitron";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Orbitron";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Orbitron";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Orbitron";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 800;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Orbitron";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
/* Keeps layout stable when the scrollbar appears so 100vw breakout sections align with the fixed footer. */
html {
  scrollbar-gutter: stable;
}

body {
  margin: 0;
  font-family: "Orbitron", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.orbitron-text {
  font-family: "Orbitron", sans-serif;
  font-size: clamp(1.4rem, 5vw, 2.5rem);
  color: #fff;
}

.header-bar {
  display: flex;
  align-items: center; /* baseline alignment doesn’t matter since both img+text share the same height */
  flex-wrap: wrap; /* if you really want it to wrap on super-narrow phones */
  min-height: 60px;
  padding-left: 0;
  padding-right: 0;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
}
@media (min-width: 380px) {
  .header-container {
    width: 90%;
  }
}
@media (min-width: 991.98px) {
  .header-container {
    width: 98%;
  }
}
@media (min-width: 1199.98px) {
  .header-container {
    width: 96%;
  }
}
@media (min-width: 1439px) {
  .header-container {
    width: 96%;
  }
}
@media (min-width: 2561px) {
  .header-container {
    width: 2400px;
  }
}

.header-bar.header-block {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  background-color: #574877;
  padding: 0 auto;
  margin-top: 0px;
  margin-bottom: 20px !important;
}
@media (min-width: 720px) {
  .header-bar.header-block {
    margin-bottom: 16px !important;
  }
}
@media (min-width: 1199.98px) {
  .header-bar.header-block {
    margin-bottom: 16px !important;
  }
}
@media (min-width: 1439px) {
  .header-bar.header-block {
    margin-bottom: 16px !important;
  }
}

.header-block {
  margin-top: 5px;
}
.logo-img {
  height: auto;
  width: 320px;
  align-self: stretch;
}
@media (min-width: 380px) {
  .logo-img {
    width: auto;
    height: 80px;
  }
}
@media (min-width: 1200px) {
  .logo-img {
    height: 86px;
  }
}
@media (min-width: 1400px) {
  .logo-img {
    height: 100px;
  }
}
@media (min-width: 1600px) {
  .logo-img {
    height: 116px;
  }
}
@media (min-width: 1920px) {
  .logo-img {
    height: 126px;
  }
}
@media (min-width: 2000px) {
  .logo-img {
    height: 160px;
  }
}

.country-select-box {
  width: 100%;
  max-width: 250px;
}

.netflix-title {
  line-height: 1;
  white-space: nowrap;
  margin-left: -10px;
}
@media (min-width: 1920px) {
  .netflix-title {
    margin-top: 10px;
  }
}
@media (min-width: 2000px) {
  .netflix-title {
    margin-top: 20px;
  }
}

.trending-scroll,
.video-scroll {
  /* Let the page handle vertical scrolling */
  max-height: none;
  overflow-y: visible;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.mb-5 {
  margin-bottom: 1.5rem !important;
}

/* ================= DEFAULT (Desktop >1200px) ================= */
.slider-container .slick-prev,
.slider-container .slick-next {
  z-index: 10;
  width: 40px;
  height: 40px;
  top: 52% !important;
  transform: translateY(-50%);
}

.slider-container .slick-prev {
  left: -35px !important;
}

.slider-container .slick-next {
  right: -35px !important;
}

/* Remove default arrow */
.slider-container .slick-prev:before,
.slider-container .slick-next:before {
  content: "" !important;
  display: none;
}

/* Custom Arrow */
.slider-container .slick-prev::after,
.slider-container .slick-next::after {
  content: "" !important;
  display: none !important;
}

/* Prev stays on-screen at first slide (desktop + tablet + mobile); inactive until user advances */
.slider-container .slick-prev.scroll-arrow.slick-disabled {
  opacity: 0.38;
  cursor: default;
}

.slider-container .slick-prev.scroll-arrow.slick-disabled::after {
  color: #8a8a8a;
}

.slider-container .slick-prev.scroll-arrow.slick-disabled:hover::after {
  color: #8a8a8a;
}

@media (max-width: 1400px) {
  .slider-container .slick-prev {
    left: -29px !important;
  }
  .slider-container .slick-next {
    right: -26px !important;
  }
  .slider-container .slick-prev::after,
  .slider-container .slick-next::after {
    font-size: 70px;
  }
}
/* ================= 1200px ================= */
@media (max-width: 1200px) {
  .slider-container .slick-prev {
    left: -28px !important;
  }
  .slider-container .slick-next {
    right: -26px !important;
  }
  .slider-container .slick-prev::after,
  .slider-container .slick-next::after {
    font-size: 50px;
  }
}
/* ================= Tablet ================= */
@media (max-width: 992px) {
  .slider-container .slick-prev {
    left: -27px !important;
  }
  .slider-container .slick-next {
    right: -25px !important;
  }
  .slider-container .slick-prev::after,
  .slider-container .slick-next::after {
    font-size: 40px;
  }
}
@media (max-width: 800px) {
  .slider-container .slick-prev {
    left: -23px !important;
  }
  .slider-container .slick-next {
    right: -20px !important;
  }
}
/* ================= Mobile ================= */
@media (max-width: 768px) {
  .slider-container.slider-row {
    padding: 0 5px !important;
  }
  .slider-container .slick-prev,
  .slider-container .slick-next {
    width: 30px;
    height: 70px;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
  .slider-container .slick-prev {
    left: 0px !important;
  }
  .slider-container .slick-next {
    right: 0px !important;
  }
  .slider-container .slick-prev::after,
  .slider-container .slick-next::after {
    font-size: 28px;
  }
}
.slick-slide h4,
h4 {
  color: #fff;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* always 2 lines */
  -webkit-box-orient: vertical;
}

@media (max-width: 768px) {
  .netflix-title {
    font-size: 1.6rem;
  }
  .country-select-box {
    margin-top: 0.5rem;
  }
  .slider-container .slick-prev,
  .slider-container .slick-next {
    transform: translateY(-50%) !important;
  }
}
.netflix-title__big {
  font-size: 1.5em; /* whatever scale you already chose */
  line-height: 1; /* so it becomes the tallest item */
}

:root {
  /* tweak this once until your proportions look perfect */
  --logo-text-size: 4.2rem;
}

/* group the logo+text so ms-auto only affects the dropdown */
.netflix-title-group {
  display: flex;
  align-items: center;
}

/* make “S” and “TV” same height as the logo */
.netflix-title__big {
  display: inline-block;
  font-size: 1.8rem;
  line-height: var(--logo-text-size);
  color: #c0c0c0;
}
@media (min-width: 720px) {
  .netflix-title__big {
    font-size: 4.2rem;
  }
}
@media (min-width: 768px) {
  .netflix-title__big {
    font-size: 2rem;
  }
}
@media (min-width: 1200px) {
  .netflix-title__big {
    font-size: 3rem;
  }
}
@media (min-width: 1920px) {
  .netflix-title__big {
    font-size: 5rem;
  }
}
@media (min-width: 2200px) {
  .netflix-title__big {
    font-size: 7rem;
  }
}
.netflix-title__big--bold {
  font-weight: 900;
}
.netflix-title__big--data-d {
  color: #555;
}
.netflix-title__big--data-a1 {
  color: #777;
}
.netflix-title__big--data-t {
  color: #aaa;
}
.netflix-title__big--data-a2 {
  color: #ccc;
}
.netflix-title__big--sci-r {
  color: #ff6666;
}
.netflix-title__big--sci-g {
  color: #66ff99;
}
.netflix-title__big--sci-b {
  color: #6666ff;
}
.netflix-title__big--sive-white {
  color: #fff;
}
.netflix-title__big--sive-black {
  color: #222;
}
.netflix-title__big--dot {
  color: #fff;
}
.netflix-title__big--tv {
  color: #fff;
}

/* size your PNG to exactly match that same height */
.netflix-title__logo {
  height: var(--logo-text-size);
  width: auto; /* keep aspect ratio */
  margin-right: 0.1rem;
  /* align-self: center; not needed—parent has align-items:center */
}

/* push country dropdown to the right, always */
.country-select-box {
  margin-left: auto;
}

/* if you want the dropdown a bit tighter vertically */
.country-select-box .form-select {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.me-2 {
  margin-right: -0.1rem !important;
  margin-top: -0.7rem !important;
}

.country-select-box {
  margin-left: 0.1rem;
  width: 100%;
  align-self: baseline;
}

.country-select-box .form-select {
  height: var(--logo-height);
}

.bold_tv {
  font-weight: bold;
}

.custom-dropdown {
  font-family: "Orbitron", sans-serif;
  position: relative;
  display: inline-block;
  font-family: inherit;
  z-index: 100;
  width: 96%;
  margin-left: 8px;
}
@media (min-width: 1199.98px) {
  .custom-dropdown {
    width: 48%;
    margin-top: -5px;
  }
}
@media (min-width: 1200px) {
  .custom-dropdown {
    margin-top: -26px;
    height: 3rem;
  }
}
@media (min-width: 1900px) {
  .custom-dropdown {
    margin-top: -16px;
    height: 4rem;
  }
}
@media (min-width: 2400px) {
  .custom-dropdown {
    margin-top: -18px;
    height: 5.6rem;
  }
}
.custom-dropdown__toggle {
  width: 100%;
  margin-top: 20px;
  padding: 0.5rem 1rem;
  background-color: #1c1c1e;
  color: #fff;
  border: 1px solid #444;
  border-radius: 5px;
  cursor: pointer;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom-dropdown__toggle:hover {
  background-color: #2a2a2d;
}
@media (min-width: 720px) {
  .custom-dropdown__toggle {
    margin-top: 0;
  }
}
@media (min-width: 1900px) {
  .custom-dropdown__toggle {
    height: 100%;
  }
}
.custom-dropdown__arrow {
  margin-left: 10px;
  font-size: 0.75em;
}
.custom-dropdown__menu {
  padding-left: 0;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: #1c1c1e;
  border: 1px solid #444;
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  margin-top: 4px;
  list-style: none;
}
.custom-dropdown__item {
  color: #fff;
  padding: 0.5rem 1rem;
  cursor: pointer;
}
.custom-dropdown__item:hover {
  background-color: #333;
}
.custom-dropdown__item.active {
  font-weight: bold;
  background-color: #444;
}

.app-main-with-footer {
  padding-bottom: 56px;
}

.main-container.container-fluid {
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.news-block__title {
  margin-bottom: 0px;
  font-size: 1rem;
  letter-spacing: 1px;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: unset !important;
  -webkit-line-clamp: unset !important;
  -webkit-box-orient: unset !important;
  margin-left: 8px;
}
@media (max-width: 720px) {
  .news-block__title {
    margin-bottom: 5px;
  }
}
@media (min-width: 1199.98px) {
  .news-block__title {
    font-size: 1.5rem;
    margin-bottom: 0px;
  }
}
@media (min-width: 1439px) {
  .news-block__title {
    font-size: 2rem;
  }
}
@media (min-width: 2561px) {
  .news-block__title {
    font-size: 2.5rem;
  }
}

.custom-next-arrow {
  position: absolute;
  top: 48%;
  right: 4px !important;
  z-index: 5;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 0 10px 10px 0;
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  transform: translateY(-50%);
  cursor: pointer;
  right: 8px;
  width: 40px;
  height: 95% !important;
  height: 92%;
}
.custom-next-arrow:hover {
  background: rgb(255, 255, 255);
}
@media (min-width: 720px) {
  .custom-next-arrow {
    width: 80px;
  }
}
@media (min-width: 495px) {
  .custom-next-arrow {
    height: 94%;
  }
}
@media (min-width: 600px) {
  .custom-next-arrow {
    height: 95%;
  }
}
@media (min-width: 720px) {
  .custom-next-arrow {
    height: 96%;
  }
}
@media (min-width: 769px) {
  .custom-next-arrow {
    height: 93%;
  }
}
@media (min-width: 950px) {
  .custom-next-arrow {
    height: 94%;
  }
}
@media (min-width: 1000px) {
  .custom-next-arrow {
    height: 91%;
  }
}
@media (min-width: 1120px) {
  .custom-next-arrow {
    height: 93%;
  }
}
@media (min-width: 1550px) {
  .custom-next-arrow {
    height: 94%;
  }
}
@media (min-width: 1960px) {
  .custom-next-arrow {
    height: 95%;
  }
}
@media (min-width: 2220px) {
  .custom-next-arrow {
    height: 96%;
  }
}

.custom-prev-arrow {
  position: absolute;
  top: 48%;
  left: 4px !important;
  z-index: 5;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  border-radius: 10px 0 0 10px;
  font-size: 1.5rem;
  width: 40px;
  height: 40px;
  transform: translateY(-50%);
  cursor: pointer;
  left: 8px;
  width: 40px;
  height: 95% !important;
  height: 92%;
}
.custom-prev-arrow:hover {
  background: rgb(255, 255, 255);
}
@media (min-width: 720px) {
  .custom-prev-arrow {
    width: 80px;
  }
}
@media (min-width: 495px) {
  .custom-prev-arrow {
    height: 94%;
  }
}
@media (min-width: 600px) {
  .custom-prev-arrow {
    height: 95%;
  }
}
@media (min-width: 720px) {
  .custom-prev-arrow {
    height: 96%;
  }
}
@media (min-width: 769px) {
  .custom-prev-arrow {
    height: 93%;
  }
}
@media (min-width: 950px) {
  .custom-prev-arrow {
    height: 94%;
  }
}
@media (min-width: 1000px) {
  .custom-prev-arrow {
    height: 91%;
  }
}
@media (min-width: 1120px) {
  .custom-prev-arrow {
    height: 93%;
  }
}
@media (min-width: 1550px) {
  .custom-prev-arrow {
    height: 94%;
  }
}
@media (min-width: 1960px) {
  .custom-prev-arrow {
    height: 95%;
  }
}
@media (min-width: 2220px) {
  .custom-prev-arrow {
    height: 96%;
  }
}

/* While a video is playing in a slider, hide nav and block swipe */
.slider-container.is-video-playing .custom-prev-arrow,
.slider-container.is-video-playing .custom-next-arrow,
.slider-container.is-video-playing .slick-prev,
.slider-container.is-video-playing .slick-next,
.slider-container.is-video-playing .slick-dots {
  opacity: 0;
  pointer-events: none;
}

.slider-container.is-video-playing .slick-list {
  touch-action: none;
}

/* Ensure react-youtube container fills the 16:9 wrapper */
.yt-fill {
  position: absolute !important;
  inset: 0 !important; /* top/right/bottom/left = 0 */
  width: 100% !important;
  height: 100% !important;
}

.yt-fill iframe,
.yt-iframe {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

/* TEMP: hide dropdown without shifting layout or interaction */
.custom-dropdown {
  visibility: hidden !important;
  pointer-events: none !important;
}

.custom-dropdown {
  display: none;
}
@media (min-width: 1200px) {
  .custom-dropdown {
    display: inline-block;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACI,uBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADEJ;ACCA;EACI,uBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADCJ;ACEA;EACI,uBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADAJ;ACGA;EACI,uBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADDJ;ACIA;EACI,uBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADFJ;ACKA;EACI,uBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ADHJ;AAvCA,2GAAA;AACA;EACI,wBAAA;AAyCJ;;AAtCA;EACI,SAAA;EACA,mCAAA;EACA,mCAAA;EACA,kCAAA;AAyCJ;;AAtCA;EACI,mCAAA;EACA,qCAAA;EACA,WAAA;AAyCJ;;AAtCA;EACI,aAAA;EACA,mBAAA,EAAA,gFAAA;EACA,eAAA,EAAA,yDAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAyCJ;;AAvCA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,WAAA;EACA,cAAA;AAyCJ;AAvCI;EARJ;IASQ,UAAA;EA0CN;AACF;AAzCI;EAXJ;IAYQ,UAAA;EA4CN;AACF;AA3CI;EAdJ;IAeQ,UAAA;EA8CN;AACF;AA7CI;EAjBJ;IAkBQ,UAAA;EAgDN;AACF;AA9CI;EArBJ;IAuBQ,aAAA;EAgDN;AACF;;AA7CA;EACI,gBAAA;EACA,MAAA;EACA,aAAA;EAEA,WAAA;EACA,yBAAA;EAEA,eAAA;EAEA,eAAA;EACA,8BAAA;AA6CJ;AA3CI;EAbJ;IAcQ,8BAAA;EA8CN;AACF;AA7CI;EAhBJ;IAiBQ,8BAAA;EAgDN;AACF;AA/CI;EAnBJ;IAoBQ,8BAAA;EAkDN;AACF;;AA/CA;EACI,eAAA;AAkDJ;AA1CA;EACI,YAAA;EACA,YAAA;EAEA,mBAAA;AA2CJ;AAzCI;EANJ;IAOQ,WAAA;IACA,YAAA;EA4CN;AACF;AA1CI;EAXJ;IAYQ,YAAA;EA6CN;AACF;AA5CI;EAdJ;IAeQ,aAAA;EA+CN;AACF;AA7CI;EAlBJ;IAmBQ,aAAA;EAgDN;AACF;AA9CI;EAtBJ;IAuBQ,aAAA;EAiDN;AACF;AA/CI;EA1BJ;IA2BQ,aAAA;EAkDN;AACF;;AA/CA;EACI,WAAA;EACA,gBAAA;AAkDJ;;AA/CA;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;AAkDJ;AAhDI;EALJ;IAMQ,gBAAA;EAmDN;AACF;AAjDI;EATJ;IAUQ,gBAAA;EAoDN;AACF;;AAjDA;;EAEI,2CAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,2BAAA;AAoDJ;;AAjDA;EACI,gCAAA;AAoDJ;;AAjDA,kEAAA;AACA;;EAEE,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;AAoDF;;AAjDA;EACE,sBAAA;AAoDF;;AAjDA;EACE,uBAAA;AAoDF;;AAjDA,yBAAA;AACA;;EAEE,sBAAA;EACA,aAAA;AAoDF;;AAjDA,iBAAA;AACA;;EAEE,sBAAA;EACA,wBAAA;AAoDF;;AAjDA,kGAAA;AACA;EACE,aAAA;EACA,eAAA;AAoDF;;AAjDA;EACE,cAAA;AAoDF;;AAjDA;EACE,cAAA;AAoDF;;AAjDA;EACI;IACE,sBAAA;EAoDJ;EAjDE;IACE,uBAAA;EAmDJ;EAhDE;;IAEE,eAAA;EAkDJ;AACF;AA/CA,+CAAA;AACA;EACE;IACE,sBAAA;EAiDF;EA9CA;IACE,uBAAA;EAgDF;EA7CA;;IAEE,eAAA;EA+CF;AACF;AA5CA,+CAAA;AACA;EAEE;IACE,sBAAA;EA6CF;EA1CA;IACE,uBAAA;EA4CF;EAzCA;;IAEE,eAAA;EA2CF;AACF;AAzCA;EAEI;IACE,sBAAA;EA0CJ;EAvCE;IACE,uBAAA;EAyCJ;AACF;AAtCA,+CAAA;AACA;EAEE;IACE,yBAAA;EAuCF;EApCA;;IAEE,WAAA;IACA,YAAA;IACA,mBAAA;IACA,sCAAA;EAsCF;EAnCA;IACE,oBAAA;EAqCF;EAlCA;IACE,qBAAA;EAoCF;EAjCA;;IAEE,eAAA;EAmCF;AACF;AA/BA;;EAEI,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA,EAAA,mBAAA;EACA,4BAAA;AAiCJ;;AA9BA;EACI;IACI,iBAAA;EAiCN;EA9BE;IACI,kBAAA;EAgCN;EA7BE;;IAEI,sCAAA;EA+BN;AACF;AA5BA;EACI,gBAAA,EAAA,qCAAA;EACA,cAAA,EAAA,mCAAA;AA8BJ;;AA3BA;EACI,wDAAA;EACA,wBAAA;AA8BJ;;AA3BA,6DAAA;AACA;EACI,aAAA;EACA,mBAAA;AA8BJ;;AA3BA,8CAAA;AACA;EACI,qBAAA;EAEA,iBAAA;EACA,kCAAA;EACA,cAAA;AA6BJ;AA3BI;EAPJ;IAQQ,iBAAA;EA8BN;AACF;AA5BI;EAXJ;IAYQ,eAAA;EA+BN;AACF;AA7BI;EAfJ;IAgBQ,eAAA;EAgCN;AACF;AA9BI;EAnBJ;IAoBQ,eAAA;EAiCN;AACF;AA/BI;EAvBJ;IAwBQ,eAAA;EAkCN;AACF;AAhCI;EACI,gBAAA;AAkCR;AA/BI;EACI,WAAA;AAiCR;AA9BI;EACI,WAAA;AAgCR;AA7BI;EACI,WAAA;AA+BR;AA5BI;EACI,WAAA;AA8BR;AAhBI;EACI,cAAA;AAkBR;AAfI;EACI,cAAA;AAiBR;AAdI;EACI,cAAA;AAgBR;AAbI;EACI,WAAA;AAeR;AAZI;EACI,WAAA;AAcR;AAXI;EACI,WAAA;AAaR;AAVI;EACI,WAAA;AAYR;;AARA,oDAAA;AACA;EACI,6BAAA;EACA,WAAA,EAAA,sBAAA;EACA,oBAAA;EACA,iEAAA;AAWJ;;AARA,+CAAA;AACA;EACI,iBAAA;AAWJ;;AARA,sDAAA;AACA;EACI,oBAAA;EACA,uBAAA;AAWJ;;AARA;EACI,gCAAA;EACA,8BAAA;AAWJ;;AARA;EACI,mBAAA;EACA,WAAA;EACA,oBAAA;AAWJ;;AARA;EACI,0BAAA;AAWJ;;AARA;EACI,iBAAA;AAWJ;;AARA;EACI,mCAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;EAEA,UAAA;EACA,gBAAA;AAUJ;AALI;EAbJ;IAcQ,UAAA;IACA,gBAAA;EAQN;AACF;AAPI;EAjBJ;IAkBQ,iBAAA;IACA,YAAA;EAUN;AACF;AATI;EArBJ;IAsBQ,iBAAA;IACA,YAAA;EAYN;AACF;AAXI;EAzBJ;IA0BQ,iBAAA;IACA,cAAA;EAcN;AACF;AAZI;EACI,WAAA;EACA,gBAAA;EAEA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EAEA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAYR;AAVQ;EACI,yBAAA;AAYZ;AATQ;EApBJ;IAqBQ,aAAA;EAYV;AACF;AAXQ;EAvBJ;IAwBQ,YAAA;EAcV;AACF;AAXI;EACI,iBAAA;EACA,iBAAA;AAaR;AAVI;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,wCAAA;EACA,eAAA;EACA,gBAAA;AAYR;AATI;EACI,WAAA;EACA,oBAAA;EACA,eAAA;AAWR;AATQ;EACI,sBAAA;AAWZ;AARQ;EACI,iBAAA;EACA,sBAAA;AAUZ;;AALA;EACI,oBAAA;AAQJ;;AALA;EACI,UAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAQJ;;AAJI;EACI,kBAAA;EAEA,eAAA;EACA,mBAAA;EAEA,4BAAA;EACA,8BAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EAEA,gBAAA;AAIR;AAFQ;EAdJ;IAeQ,kBAAA;EAKV;AACF;AAJQ;EAjBJ;IAkBQ,iBAAA;IACA,kBAAA;EAOV;AACF;AANQ;EArBJ;IAsBQ,eAAA;EASV;AACF;AARQ;EAxBJ;IAyBQ,iBAAA;EAWV;AACF;;AA4BA;EACI,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EAMA,UAAA;EACA,WAAA;EACA,sBAAA;EAtDA,WAAA;AAyBJ;AAuBI;EACI,8BAAA;AArBR;AA4BI;EAtBJ;IAuBQ,WAAA;EAzBN;AACF;AA/BI;EAgCJ;IA/BQ,WAAA;EAkCN;AACF;AAjCI;EA6BJ;IA5BQ,WAAA;EAoCN;AACF;AAnCI;EA0BJ;IAzBQ,WAAA;EAsCN;AACF;AArCI;EAuBJ;IAtBQ,WAAA;EAwCN;AACF;AAvCI;EAoBJ;IAnBQ,WAAA;EA0CN;AACF;AAzCI;EAiBJ;IAhBQ,WAAA;EA4CN;AACF;AA3CI;EAcJ;IAbQ,WAAA;EA8CN;AACF;AA7CI;EAWJ;IAVQ,WAAA;EAgDN;AACF;AA/CI;EAQJ;IAPQ,WAAA;EAkDN;AACF;AAjDI;EAKJ;IAJQ,WAAA;EAoDN;AACF;;AApBA;EACI,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EAMA,SAAA;EACA,WAAA;EACA,sBAAA;EAnFA,WAAA;AAsGJ;AAzBI;EACI,8BAAA;AA2BR;AApBI;EAtBJ;IAuBQ,WAAA;EAuBN;AACF;AA5GI;EA6DJ;IA5DQ,WAAA;EA+GN;AACF;AA9GI;EA0DJ;IAzDQ,WAAA;EAiHN;AACF;AAhHI;EAuDJ;IAtDQ,WAAA;EAmHN;AACF;AAlHI;EAoDJ;IAnDQ,WAAA;EAqHN;AACF;AApHI;EAiDJ;IAhDQ,WAAA;EAuHN;AACF;AAtHI;EA8CJ;IA7CQ,WAAA;EAyHN;AACF;AAxHI;EA2CJ;IA1CQ,WAAA;EA2HN;AACF;AA1HI;EAwCJ;IAvCQ,WAAA;EA6HN;AACF;AA5HI;EAqCJ;IApCQ,WAAA;EA+HN;AACF;AA9HI;EAkCJ;IAjCQ,WAAA;EAiIN;AACF;;AAnEA,mEAAA;AACA;;;;;EAKI,UAAA;EACA,oBAAA;AAsEJ;;AAnEA;EACI,kBAAA;AAsEJ;;AAnEA,0DAAA;AACA;EACI,6BAAA;EACA,mBAAA,EAAA,8BAAA;EACA,sBAAA;EACA,uBAAA;AAsEJ;;AApEA;;EAEI,sBAAA;EACA,uBAAA;EACA,cAAA;AAuEJ;;AApEA,+DAAA;AACA;EACI,6BAAA;EACA,+BAAA;AAuEJ;;AApEA;EACI,aAAA;AAuEJ;AAtEI;EAFJ;IAGQ,qBAAA;EAyEN;AACF","sourcesContent":["@use './styles/variables' as *;\n@use './styles/fonts';\n\n/* Keeps layout stable when the scrollbar appears so 100vw breakout sections align with the fixed footer. */\nhtml {\n    scrollbar-gutter: stable;\n}\n\nbody {\n    margin: 0;\n    font-family: 'Orbitron', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.orbitron-text {\n    font-family: 'Orbitron', sans-serif;\n    font-size: clamp(1.4rem, 5vw, 2.5rem);\n    color: #fff;\n}\n\n.header-bar {\n    display: flex;\n    align-items: center; /* baseline alignment doesn’t matter since both img+text share the same height */\n    flex-wrap: wrap; /* if you really want it to wrap on super-narrow phones */\n    min-height: 60px;\n    padding-left: 0;\n    padding-right: 0;\n}\n.header-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    width: 100%;\n    margin: 0 auto;\n\n    @media (min-width: 380px) {\n        width: 90%;\n    }\n    @media (min-width: $tablet-album) {\n        width: 98%;\n    }\n    @media (min-width: $small-desktop-width) {\n        width: 96%;\n    }\n    @media (min-width: $desktop-width) {\n        width: 96%;\n    }\n\n    @media (min-width: 2561px) {\n        // from size more then 2k\n        width: 2400px;\n    }\n}\n\n.header-bar.header-block {\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n\n    width: 100%;\n    background-color: #574877;\n\n    padding: 0 auto;\n\n    margin-top: 0px;\n    margin-bottom: 20px !important;\n\n    @media (min-width: $tablet-width) {\n        margin-bottom: 16px !important;\n    }\n    @media (min-width: $small-desktop-width) {\n        margin-bottom: 16px !important;\n    }\n    @media (min-width: $desktop-width) {\n        margin-bottom: 16px !important;\n    }\n}\n\n.header-block {\n    margin-top: 5px;\n    &__title {\n        @media (min-width: $tablet-width) {\n            // margin-bottom: 20px;\n        }\n    }\n}\n\n.logo-img {\n    height: auto;\n    width: 320px;\n\n    align-self: stretch;\n\n    @media (min-width: 380px) {\n        width: auto;\n        height: 80px;\n    }\n\n    @media (min-width: 1200px) {\n        height: 86px;\n    }\n    @media (min-width: 1400px) {\n        height: 100px;\n    }\n\n    @media (min-width: 1600px) {\n        height: 116px;\n    }\n\n    @media (min-width: 1920px) {\n        height: 126px;\n    }\n\n    @media (min-width: 2000px) {\n        height: 160px;\n    }\n}\n\n.country-select-box {\n    width: 100%;\n    max-width: 250px;\n}\n\n.netflix-title {\n    line-height: 1;\n    white-space: nowrap;\n    margin-left: -10px;\n\n    @media (min-width: 1920px) {\n        margin-top: 10px;\n    }\n\n    @media (min-width: 2000px) {\n        margin-top: 20px;\n    }\n}\n\n.trending-scroll,\n.video-scroll {\n    /* Let the page handle vertical scrolling */\n    max-height: none;\n    overflow-y: visible;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n}\n\n.mb-5 {\n    margin-bottom: 1.5rem !important;\n}\n\n/* ================= DEFAULT (Desktop >1200px) ================= */\n.slider-container .slick-prev,\n.slider-container .slick-next {\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  top: 52% !important;\n  transform: translateY(-50%);\n}\n\n.slider-container .slick-prev {\n  left: -35px !important;\n}\n\n.slider-container .slick-next {\n  right: -35px !important;\n}\n\n/* Remove default arrow */\n.slider-container .slick-prev:before,\n.slider-container .slick-next:before {\n  content: '' !important;\n  display: none;\n}\n\n/* Custom Arrow */\n.slider-container .slick-prev::after,\n.slider-container .slick-next::after {\n  content: '' !important;\n  display: none !important;\n}\n\n/* Prev stays on-screen at first slide (desktop + tablet + mobile); inactive until user advances */\n.slider-container .slick-prev.scroll-arrow.slick-disabled {\n  opacity: 0.38;\n  cursor: default;\n}\n\n.slider-container .slick-prev.scroll-arrow.slick-disabled::after {\n  color: #8a8a8a;\n}\n\n.slider-container .slick-prev.scroll-arrow.slick-disabled:hover::after {\n  color: #8a8a8a;\n}\n\n@media (max-width: 1400px) {\n    .slider-container .slick-prev {\n      left: -29px !important;\n    }\n  \n    .slider-container .slick-next {\n      right: -26px !important;\n    }\n  \n    .slider-container .slick-prev::after,\n    .slider-container .slick-next::after {\n      font-size: 70px;\n    }\n  }\n\n/* ================= 1200px ================= */\n@media (max-width: 1200px) {\n  .slider-container .slick-prev {\n    left: -28px !important;\n  }\n\n  .slider-container .slick-next {\n    right: -26px !important;\n  }\n\n  .slider-container .slick-prev::after,\n  .slider-container .slick-next::after {\n    font-size: 50px;\n  }\n}\n\n/* ================= Tablet ================= */\n@media (max-width: 992px) {\n\n  .slider-container .slick-prev {\n    left: -27px !important;\n  }\n\n  .slider-container .slick-next {\n    right: -25px !important;\n  }\n\n  .slider-container .slick-prev::after,\n  .slider-container .slick-next::after {\n    font-size: 40px;\n  }\n}\n@media (max-width: 800px) {\n\n    .slider-container .slick-prev {\n      left: -23px !important;\n    }\n  \n    .slider-container .slick-next {\n      right: -20px !important;\n    }\n}\n\n/* ================= Mobile ================= */\n@media (max-width: 768px) {\n\n  .slider-container.slider-row {\n    padding: 0 5px !important;\n  }\n\n  .slider-container .slick-prev,\n  .slider-container .slick-next {\n    width: 30px;\n    height: 70px;\n    top: 50% !important;\n    transform: translateY(-50%) !important;\n  }\n\n  .slider-container .slick-prev {\n    left: 0px !important;\n  }\n\n  .slider-container .slick-next {\n    right: 0px !important;\n  }\n\n  .slider-container .slick-prev::after,\n  .slider-container .slick-next::after {\n    font-size: 28px;\n  }\n\n}\n\n.slick-slide h4,\nh4 {\n    color: #fff;\n    font-size: 1.2rem;\n    margin-bottom: 0.5rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2; /* always 2 lines */\n    -webkit-box-orient: vertical;\n}\n\n@media (max-width: 768px) {\n    .netflix-title {\n        font-size: 1.6rem;\n    }\n\n    .country-select-box {\n        margin-top: 0.5rem;\n    }\n\n    .slider-container .slick-prev,\n    .slider-container .slick-next {\n        transform: translateY(-50%) !important;\n    }\n}\n\n.netflix-title__big {\n    font-size: 1.5em; /* whatever scale you already chose */\n    line-height: 1; /* so it becomes the tallest item */\n}\n\n:root {\n    /* tweak this once until your proportions look perfect */\n    --logo-text-size: 4.2rem;\n}\n\n/* group the logo+text so ms-auto only affects the dropdown */\n.netflix-title-group {\n    display: flex;\n    align-items: center;\n}\n\n/* make “S” and “TV” same height as the logo */\n.netflix-title__big {\n    display: inline-block;\n    // font-size: var(--logo-text-size);\n    font-size: 1.8rem;\n    line-height: var(--logo-text-size);\n    color: #c0c0c0;\n\n    @media (min-width: 720px) {\n        font-size: 4.2rem;\n    }\n\n    @media (min-width: 768px) {\n        font-size: 2rem;\n    }\n\n    @media (min-width: 1200px) {\n        font-size: 3rem;\n    }\n\n    @media (min-width: 1920px) {\n        font-size: 5rem;\n    }\n\n    @media (min-width: 2200px) {\n        font-size: 7rem;\n    }\n\n    &--bold {\n        font-weight: 900;\n    }\n\n    &--data-d {\n        color: #555;\n    }\n\n    &--data-a1 {\n        color: #777;\n    }\n\n    &--data-t {\n        color: #aaa;\n    }\n\n    &--data-a2 {\n        color: #ccc;\n    }\n\n    // &--sci-r {\n    //     color: #ff9999;\n    // }\n\n    // &--sci-g {\n    //     color: #99ff99;\n    // }\n\n    // &--sci-b {\n    //     color: #9999ff;\n    // }\n    &--sci-r {\n        color: #ff6666; // более насыщенный, но не неоновый красный\n    }\n\n    &--sci-g {\n        color: #66ff99; // ярко-зелёный с мягким оттенком\n    }\n\n    &--sci-b {\n        color: #6666ff; // более выраженный синий, но без кислотности\n    }\n\n    &--sive-white {\n        color: #fff;\n    }\n\n    &--sive-black {\n        color: #222;\n    }\n\n    &--dot {\n        color: #fff;\n    }\n\n    &--tv {\n        color: #fff;\n    }\n}\n\n/* size your PNG to exactly match that same height */\n.netflix-title__logo {\n    height: var(--logo-text-size);\n    width: auto; /* keep aspect ratio */\n    margin-right: 0.1rem;\n    /* align-self: center; not needed—parent has align-items:center */\n}\n\n/* push country dropdown to the right, always */\n.country-select-box {\n    margin-left: auto;\n}\n\n/* if you want the dropdown a bit tighter vertically */\n.country-select-box .form-select {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n}\n\n.me-2 {\n    margin-right: -0.1rem !important;\n    margin-top: -0.7rem !important;\n}\n\n.country-select-box {\n    margin-left: 0.1rem;\n    width: 100%;\n    align-self: baseline;\n}\n\n.country-select-box .form-select {\n    height: var(--logo-height);\n}\n\n.bold_tv {\n    font-weight: bold;\n}\n\n.custom-dropdown {\n    font-family: 'Orbitron', sans-serif;\n    position: relative;\n    display: inline-block;\n    font-family: inherit;\n    z-index: 100;\n\n    width: 96%;\n    margin-left: 8px;\n\n    // @media (min-width: $tablet-width) {\n\n    // }\n    @media (min-width: $small-desktop-width) {\n        width: 48%;\n        margin-top: -5px;\n    }\n    @media (min-width: 1200px) {\n        margin-top: -26px;\n        height: 3rem;\n    }\n    @media (min-width: 1900px) {\n        margin-top: -16px;\n        height: 4rem;\n    }\n    @media (min-width: 2400px) {\n        margin-top: -18px;\n        height: 5.6rem;\n    }\n\n    &__toggle {\n        width: 100%;\n        margin-top: 20px;\n\n        padding: 0.5rem 1rem;\n        background-color: #1c1c1e;\n        color: #fff;\n        border: 1px solid #444;\n        border-radius: 5px;\n        cursor: pointer;\n        // width: 200px;\n        text-align: left;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        &:hover {\n            background-color: #2a2a2d;\n        }\n\n        @media (min-width: $tablet-width) {\n            margin-top: 0;\n        }\n        @media (min-width: 1900px) {\n            height: 100%;\n        }\n    }\n\n    &__arrow {\n        margin-left: 10px;\n        font-size: 0.75em;\n    }\n\n    &__menu {\n        padding-left: 0;\n        position: absolute;\n        top: 100%;\n        left: 0;\n        width: 100%;\n        background-color: #1c1c1e;\n        border: 1px solid #444;\n        border-radius: 5px;\n        max-height: 200px;\n        overflow-y: auto;\n        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n        margin-top: 4px;\n        list-style: none;\n    }\n\n    &__item {\n        color: #fff;\n        padding: 0.5rem 1rem;\n        cursor: pointer;\n\n        &:hover {\n            background-color: #333;\n        }\n\n        &.active {\n            font-weight: bold;\n            background-color: #444;\n        }\n    }\n}\n\n.app-main-with-footer {\n    padding-bottom: 56px;\n}\n\n.main-container.container-fluid {\n    padding: 0;\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\n.news-block {\n    &__title {\n        margin-bottom: 0px;\n        // margin-bottom: 20px;\n        font-size: 1rem;\n        letter-spacing: 1px;\n\n        overflow: visible !important;\n        white-space: normal !important;\n        text-overflow: unset !important;\n        -webkit-line-clamp: unset !important;\n        -webkit-box-orient: unset !important;\n\n        margin-left: 8px;\n\n        @media (max-width: $tablet-width) {\n            margin-bottom: 5px;\n        }\n        @media (min-width: $small-desktop-width) {\n            font-size: 1.5rem;\n            margin-bottom: 0px;\n        }\n        @media (min-width: $desktop-width) {\n            font-size: 2rem;\n        }\n        @media (min-width: 2561px) {\n            font-size: 2.5rem;\n        }\n    }\n}\n\n@mixin arrow-heights {\n    height: 92%;\n\n    @media (min-width: 495px) {\n        height: 94%;\n    }\n    @media (min-width: 600px) {\n        height: 95%;\n    }\n    @media (min-width: 720px) {\n        height: 96%;\n    }\n    @media (min-width: 769px) {\n        height: 93%;\n    }\n    @media (min-width: 950px) {\n        height: 94%;\n    }\n    @media (min-width: 1000px) {\n        height: 91%;\n    }\n    @media (min-width: 1120px) {\n        height: 93%;\n    }\n    @media (min-width: 1550px) {\n        height: 94%;\n    }\n    @media (min-width: 1960px) {\n        height: 95%;\n    }\n    @media (min-width: 2220px) {\n        height: 96%;\n    }\n}\n\n.custom-next-arrow {\n    position: absolute;\n    top: 48%;\n    right: 4px !important;\n    z-index: 5;\n    background: rgba(255, 255, 255, 0.8);\n    border: none;\n    border-radius: 0 10px 10px 0;\n    font-size: 1.5rem;\n    width: 40px;\n    height: 40px;\n    transform: translateY(-50%);\n    cursor: pointer;\n\n    &:hover {\n        background: rgba(255, 255, 255, 1);\n    }\n\n    right: 8px;\n    width: 40px;\n    height: 95% !important;\n\n    @media (min-width: $tablet-width) {\n        width: 80px;\n    }\n\n    @include arrow-heights;\n}\n\n.custom-prev-arrow {\n    position: absolute;\n    top: 48%;\n    left: 4px !important;\n    z-index: 5;\n    background: rgba(255, 255, 255, 0.8);\n    border: none;\n    border-radius: 10px 0 0 10px;\n    font-size: 1.5rem;\n    width: 40px;\n    height: 40px;\n    transform: translateY(-50%);\n    cursor: pointer;\n\n    &:hover {\n        background: rgba(255, 255, 255, 1);\n    }\n\n    left: 8px;\n    width: 40px;\n    height: 95% !important;\n\n    @media (min-width: $tablet-width) {\n        width: 80px;\n    }\n\n    @include arrow-heights;\n}\n\n// ------- test options --------\n/* While a video is playing in a slider, hide nav and block swipe */\n.slider-container.is-video-playing .custom-prev-arrow,\n.slider-container.is-video-playing .custom-next-arrow,\n.slider-container.is-video-playing .slick-prev,\n.slider-container.is-video-playing .slick-next,\n.slider-container.is-video-playing .slick-dots {\n    opacity: 0;\n    pointer-events: none;\n}\n\n.slider-container.is-video-playing .slick-list {\n    touch-action: none;\n}\n\n/* Ensure react-youtube container fills the 16:9 wrapper */\n.yt-fill {\n    position: absolute !important;\n    inset: 0 !important; /* top/right/bottom/left = 0 */\n    width: 100% !important;\n    height: 100% !important;\n}\n.yt-fill iframe,\n.yt-iframe {\n    width: 100% !important;\n    height: 100% !important;\n    display: block;\n}\n\n/* TEMP: hide dropdown without shifting layout or interaction */\n.custom-dropdown {\n    visibility: hidden !important;\n    pointer-events: none !important;\n}\n\n.custom-dropdown {\n    display: none;\n    @media (min-width: 1200px) {\n        display: inline-block;\n    }\n}\n","@font-face {\n    font-family: 'Orbitron';\n    src: url('../fonts/Orbitron-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Orbitron';\n    src: url('../fonts/Orbitron-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Orbitron';\n    src: url('../fonts/Orbitron-SemiBold.ttf') format('truetype');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Orbitron';\n    src: url('../fonts/Orbitron-Bold.ttf') format('truetype');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Orbitron';\n    src: url('../fonts/Orbitron-ExtraBold.ttf') format('truetype');\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n}\n\n@font-face {\n    font-family: 'Orbitron';\n    src: url('../fonts/Orbitron-Black.ttf') format('truetype');\n    font-weight: 900;\n    font-style: normal;\n    font-display: swap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
